import React from 'react'
import { Divider, Card, Col, Row, Badge, Calendar } from 'antd'

function getListData (value) {
  let listData
  switch (value.date()) {
    case 8:
      listData = [
        { type: 'warning', content: 'This is warning event.' },
        { type: 'success', content: 'This is usual event.' }
      ]
      break
    case 10:
      listData = [
        { type: 'warning', content: 'This is warning event.' },
        { type: 'success', content: 'This is usual event.' },
        { type: 'error', content: 'This is error event.' }
      ]
      break
    case 15:
      listData = [
        { type: 'warning', content: 'This is warning event' },
        { type: 'success', content: 'This is very long usual event。。....' },
        { type: 'error', content: 'This is error event 1.' },
        { type: 'error', content: 'This is error event 2.' },
        { type: 'error', content: 'This is error event 3.' },
        { type: 'error', content: 'This is error event 4.' }
      ]
      break
    default:
  }
  return listData || []
}

function dateCellRender(value) {
  const listData = getListData(value)
  return (
    <ul className='events'>
      {listData.map((item) => (
        <li key={item.content}>
          <Badge status={item.type} text={item.content} />
        </li>
      ))}
    </ul>
  )
}

const CalendarView = () => {
  return (
    <>
      <Calendar dateCellRender={dateCellRender} />
      <Divider />
      <div className='site-card-wrapper'>
        <Row gutter={16}>
          <Col span={12}>
            <Badge.Ribbon text='Actives'>
              <Card title='Jobs' bordered={false}>
                Jobs
              </Card>
            </Badge.Ribbon>
          </Col>
          <Col span={12}>
            <Badge.Ribbon text='Actives'>
              <Card title='Purchase Order' bordered={false}>
                Purchase Order
              </Card>
            </Badge.Ribbon>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default CalendarView
